
import { useEffect, useCallback, useMemo, useState, useRef, useContext, useImperativeHandle, forwardRef, } from "react";
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';

/*import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-quartz.css";*/
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-balham.css"; 
import "./customStyles.css";

import { ModuleRegistry } from '@ag-grid-community/core';
import { DDD, E2Data } from "../../lib/ddd/ddd";
import {currencyToCountryMap} from "./currency_flags";
import { ReactComponent as EditBtn } from "../../assets/enter.svg";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import classes from "./CustomersGrid.module.scss";
import { NotificationManager} from 'react-notifications';
import useEffectIgnoreFirst from "../../hooks/useEffectIgnoreFirst";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import HelpIcon from '@mui/icons-material/Help';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import JoinFullIcon from '@mui/icons-material/JoinFull';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import FiberNewIcon from '@mui/icons-material/FiberNew'; 
import TagIcon from '@mui/icons-material/Tag';
import {
    Receipt,         // Default invoice
    Description,     // Proforma
    EditNote,        // Corrective
    ReceiptLong,     // Construction-related
    Paid,            // Advance
    CreditScore,     // Credit note
    AttachMoney,     // Partial
    History,         // Self-invoice
    WarningAmber,    // Special cases,
    MonetizationOn, CreditCard, Payments, HelpOutline, // Payment types
    Storefront, BusinessCenter,
    MoveToInbox, // Sale types
} from '@mui/icons-material';
import { 
    Box, 
    Tooltip as MuiTooltip,
} from '@mui/material';
import PaidIcon from '@mui/icons-material/Paid';
import DescriptionIcon from '@mui/icons-material/Description';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MessageIcon from '@mui/icons-material/Message';
import ApprovedIcon from '@mui/icons-material/CheckCircle';
import RejectedIcon from '@mui/icons-material/Cancel';
import PaymentIcon from '@mui/icons-material/AttachMoney';
import CancelledIcon from '@mui/icons-material/HighlightOff';
import SentIcon from '@mui/icons-material/Send';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import StornoIcon from '@mui/icons-material/Replay';
import QuarantineIcon from '@mui/icons-material/ReportProblem';
import ArchivedIcon from '@mui/icons-material/Archive';
import SeenIcon from '@mui/icons-material/RemoveRedEye';
import RemindedIcon from '@mui/icons-material/NotificationsActive';
import WaitingIcon from '@mui/icons-material/Schedule';
import UnknownIcon from '@mui/icons-material/HelpOutline';
import { normalizeLocaleCode } from "../../lib/normalizeLocaleCode";

ModuleRegistry.registerModules([InfiniteRowModelModule]);

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const userPreferences = {
    __invoiceType: {
        order : 1,
        width: 175,
    },
    TAP_BuyerInvoiceId: {
        order : 5,
        width: 150,
    },
    InvNumREI: {
        order : 1,
        width: 150,
        header : "InvNum",
    },
    TAP_DeployDateTime: {
        order : 7,
        width: 150,
        header : "TAP Received",
    },
    InvIssueDate: {
        order : 8,
        width: 150,
        header : "Issued",
    },
    TAP_SellerInvId: {
        order : 6,
        width: 170,
    },
    InvNum: {
        order : 2,
        width: 150,
        header : "Seller InvNum",
    },
    SellerFormalName: {
        order : 9,
        width: 120,
        header : "Seller name",
    },
    SellerTaxNum: {
        order : 10,
        width: 160,
        header : "Seller Tax number",
    },
    SellerCounCode: {
        order : 11,
        width: 150,
        header : "Seller country",
    },
    InvAmountExclVat: {
        order : 12,
        width: 120,
        header : "Amount Excl. VAT",
    },
    InvAmountInclVat: {
        order : 13,
        width: 120,
        headerTooltip : "DocTotalAmount",
        header : "Amount Incl. VAT",
    },
    InvCurrencyCode: {
        order : 15,
        width: 120,
        headerTooltip : "DocCurrencyCode",
        header : "Currency",
    },
    InvTotalVatAmountCC: {
        order : 14,
        width: 120,
        header : "Amount VAT",
    },
    InvPrepaidAmount: {
        order : 16,
        width: 120,
        header : "Amount Prepaid",
    },
    InvPayableAmount: {
        order : 17,
        width: 120,
        headerTooltip : "Amount Payable",
    },
    InvStartDate: {
        order : 18,
        width: 100,
        headerTooltip : "DocStartDate",
        header : "Started",
    },
    InvEndDate: {
        order : 19,
        width: 100,
        headerTooltip : "DocEndDate",
        header : "Ended",
    },
    InvDueDate: {
        order : 20,
        width: 100,
        headerTooltip : "DocEndDate",
        header : "Duedate",
    },
    DeliveryDateActual: {
        order : 21,
        width: 100,
        headerTooltip : "DocEndDate",
        header : "Delivered",
    },
    BuyerOrderRef: {
        order : 22,
        width: 150,
		header : "BuyerOrder",
    },
	ContractRef: {
        order : 23,
        width: 150,
		header : "Contract",
    },
	BuyerRef: {
        order : 24,
        width: 150,
		header : "BuyerRef",
    },
    InvStatusSC__TAP_Status: {
        order : 25,
        width: 200,
        sort: undefined,
    },
    Source: {
        order : 26,
        width: 150,
    },
    DateTimeCreate: {
        order : 4,
        width: 150,
        sort:"desc",
        header : "Received",
    },
    FiscMoment: {
        order : 27,
        width: 150,
    },
    FiscTANum: {
        order : 28,
        width: 250,
    },
    FiscOperatorRegCode: {
        order : 29,
        width: 150,
    },
    Peppol_RR_DateTime: {
        order : 30,
        width: 150,
    },
    Peppol_RR_ReceiverEA: {
        order : 31,
        width: 150,
    },
    NET_DateTime: {
        order : 32,
        width: 150,
    },
    NET_UniqueInvId: {
        order : 33,
        width: 150,
    },
    PUSH_ERPDateTime: {
        order : 34,
        width: 150,
    },
    Mode: {
        order : 35,
        width: 80,
    },
}
const InvoicesTableREI = forwardRef(({search, type, range, range2, state, reloadNum, filter, entityInfo, onRowSelect, tableModel, dateField, dateField2, stepsData, mode, onRightClick}, ref) =>{
    const table =useRef();
    const [requestParams, setRequestParams] = useState();
    const {sessionInfo, mainOrgId} = useContext(OrgIdContext)
    const [totalRecords, setTotalRecords] = useState("-");
    const [currentFilter, setCurrentFilter] = useState();
    const { t, i18n } = useTranslation();
    const userSettings = mergeObjects({...userPreferences},tableModel);
    const currentLanguage = normalizeLocaleCode(i18n.language);

    useImperativeHandle(ref, () => ({
        getColumnSettings: getColumnSettings,
    }), [table, requestParams]);

    const getSelect = (obj, excludeFields = [], addFields = []) => {
        let fields = Object.keys(obj);
        if (excludeFields.length) {
            fields = fields.filter(f => !excludeFields.includes(f));
        }
        if (addFields.length) {
            fields.push(...addFields);
        }

        return fields;
    }

    const columnDefs = useMemo(() => {
        const colArr = [
            {
              field: "Step",
              width: 28,
              minWidth: 28,
              maxWidth: 28,
              pinned: "left",
              sortable: false,
              filter: false,
              resizable: false,
              suppressMenu: true,
              headerComponent: () => (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    boxSizing: "border-box", // important for small column
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <MuiTooltip title="Step" placement="top">
                    <Box
                      sx={{
                        width: '1rem',
                        height: '1rem',
                        minWidth: '1rem',
                        minHeight: '1rem',
                        borderRadius: '50%',
                        opacity: 0.5,
                        backgroundColor: 'black',
                        color: 'white',
                        border: '1px solid black',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.6rem',
                        lineHeight: 1,
                      }}
                    >
                      S
                    </Box>
                  </MuiTooltip>
                </div>
              ),
              cellStyle: {
                padding: 0,
                margin: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxSizing: "border-box",
              },
              cellRenderer: (params) => {
              const stepInfo = stepsData.find(s => s.Step === params?.data?.Step);
              const status = params?.data?.StepStatus;
            
              const tooltipTitle = (status || stepInfo?.StepUIDescription)
                  ? <>{status && <>Status: {status}<br/></>}{stepInfo?.StepUIDescription && <>Step: {stepInfo?.StepUIDescription}</>}</>
                  : ''
            
              let bgColor = "var(--main-blue)";
              let textColor = "#fff";
            
               if (status === "Error") bgColor = "#f8b3b3";
              else if (status === "Warning") bgColor = "#b3d4fc";
              else if (status === "Pending") bgColor = "#ffe0b2";
              else if (status === "Draft") bgColor = "#cde3e9";
              if(bgColor !== "var(--main-blue)")textColor = "#000";
              return (
                <MuiTooltip title={tooltipTitle} placement="top">
                  <Box
                    sx={{
                      width: '1rem',
                      height: '1rem',
                      borderRadius: '50%',
                      backgroundColor: bgColor,
                      color: textColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.6rem',
                      lineHeight: 1,
                      fontFamily: 'monospace'
                    }}
                  >
                    {params?.data?.Step || "?"}
                  </Box>
                </MuiTooltip>
              );
            }
            },{
            field : "__invoiceType",
            headerName : t(""),
            sortable : false,
            maxWidth:160,
            minWidth: 160,
            flex:1,
            cellStyle : {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign :"center"
            },
            headerComponent:  (props) => {
                    return (<>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "center", flex: 1 }}>    
                            {/* <MuiTooltip title="Step" placement="top">
                            <Box
                                sx={{
                                width: '1rem',
                                height: '1rem',
                                borderRadius: '50%',
                                opacity: 0.5,
                                backgroundColor: 'black',
                                color: 'white',
                                border: '1px solid black',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '0.6rem',
                                lineHeight: 1,
                                }}
                            >
                                S
                            </Box>
                            </MuiTooltip> */}

                            <MuiTooltip title="DocTypeCode" placement="top">
                            <DescriptionIcon fontSize="small" />
                            </MuiTooltip>

                            <MuiTooltip title="DocPaymentTypeCode" placement="top">
                            <PaidIcon fontSize="small" />
                            </MuiTooltip>

                            <MuiTooltip title="DocSaleTypeCode" placement="top">
                                <StorefrontIcon fontSize="small" />
                            </MuiTooltip>

                            <MuiTooltip title="PDFOriginal" placement="top">
                                <PictureAsPdfIcon fontSize="small" />
                            </MuiTooltip>
                            <MuiTooltip title="TAP status" placement="top">
                                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" 
                                            fill="#707171" 
                                            stroke="black" 
                                            stroke-width="1"/>
                                    <text x="12" y="15" 
                                            //font-family="Arial, sans-serif" 
                                            font-size="8" 
                                            //font-weight="bold" 
                                            text-anchor="middle" 
                                            fill="white">TAP</text>
                                </svg>
                            </MuiTooltip>

                        </div>
                    </>);
                },
            cellRenderer : (params) => {
                let color = 'white'
                switch (params?.data?.StepStatus) {
                    case 'Error':
                        color = 'white';
                        break;
                    case 'Warning':
                    case 'Pending':
                        //color = '#FFA500';
                        color = 'white';
                        break;
                    default:
                        break;
                }
                return (<> 
                {/* <MuiTooltip title={stepsData.find(s => s.Step === params?.data?.Step)?.StepUIDescription || ''} placement="top">
                    <Box
                        sx={{
                            width: '1rem',
                            height: '1rem',
                            borderRadius: '50%',
                            backgroundColor: 'var(--main-blue)',
                            color: color,
                            //border: '1px solid black',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            //fontWeight: 'bold',
                            fontSize: '0.6rem', // small enough to fit double digits
                            lineHeight: 1,
                        }}
                    >
                        {params?.data?.Step}
                    </Box>
                </MuiTooltip> */}
                <MuiTooltip title={params?.data?.InvTypeCodeNameSC__Code} placement="top">
                    <span>{getInvoiceTypeIcon(params?.data?.InvTypeCodeNameSC__Code)}</span>
                </MuiTooltip>

                <MuiTooltip title={params?.data?.InvPaymentTypeCodeNameSC__Code} placement="top">
                    <span>{getPaymentTypeIcon(params?.data?.InvPaymentTypeCodeNameSC__Code)}</span>
                </MuiTooltip>

                <MuiTooltip title={params?.data?.InvSaleTypeSC__Code} placement="top">
                <span>{getSaleTypeIcon(params?.data?.InvSaleTypeSC__Code)}</span>
                </MuiTooltip>

                <MuiTooltip
                    title={
                        params?.data?.PDFOriginal
                        ? t('Has original PDF')
                        : t('Does not have original PDF')
                    }
                    placement="top"
                    >
                    <span>{getPDFOriginalIcon(params?.data?.PDFOriginal)}</span>
                </MuiTooltip>

                <MuiTooltip
                title={
                    <div>
                    {params?.data?.InvStatusSC__TAP_Status && (
                        <>
                        <strong>{t("Status")}:</strong> {params.data.InvStatusSC__TAP_Status}
                        <br />
                        </>
                    )}
                    {params?.data?.TAP_Comment && (
                        <>
                        <strong>{t("Comment")}:</strong> {params.data.TAP_Comment}
                        </>
                    )}
                    </div>
                }
                placement="top"
                >
                <span>{getStatusIcon(params?.data?.InvStatusSC__TAP_Status)}</span>
                </MuiTooltip>
                </>)
            },
            ...userSettings.__invoiceType,
        },
        {
            field : "TAP_BuyerInvoiceId",
            headerName: t("Buyer Invoice Id"),
            sortable : true,
            headerComponent: TapHeaderComponent,
            ...userSettings.TAP_BuyerInvoiceId,
        },
        {
            field : "InvNumREI",
            headerName : "InvNum",
            sortable : true,
            ...userSettings.InvNumREI,
        },
        {
            field : "TAP_DeployDateTime",
            headerName : t("TAP Received"),
            sortable : true,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.TAP_DeployDateTime,
        },
        {
            field : "InvIssueDate",
            headerName : t("Issued"),
            sortable : true,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.InvIssueDate,
        },
        {
            field : "TAP_SellerInvId",
            headerName: t("Seller Invoice Id"),
            sortable : true,
            headerComponent: TapHeaderComponent,
            ...userSettings.TAP_SellerInvId,
        },
        {
            field : "InvNum",
            headerName : t("Seller InvNum"),
            sortable : true,
            ...userSettings.InvNum,
        },
        {
            field : "SellerFormalName",
            headerName : t("Seller name"),
            sortable : true,
            ...userSettings.SellerFormalName,
        },
        {
            field : "Mode",
            headerName : t("Mode"),
            cellStyle : {
                textAlign :"center"
            },
            ...userSettings.Mode,
        },
        {
            field : "SellerTaxNum",
            headerName : t("Seller Tax number"),
            ...userSettings.SellerTaxNum,
        },
        {
            field : "SellerCounCode",
            headerName : t("Seller country"),
            cellStyle : {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            cellRenderer: (params) => {
                if (!params.value) return "";
                const countryCode = params.value.toLowerCase(); // API needs lowercase (e.g., "kw", "de")
                const flagUrl = `https://flagcdn.com/16x12/${countryCode}.png`; // 16x12px flag image
                return <>
                    <img src={flagUrl} alt={params.value} style={{ width: "16px", height: "12px" }} onerror="this.style.display='none'" />
                    <span style={{ marginLeft: "5px" }}>{params.value}</span>
                </>;
            },
            ...userSettings.SellerCounCode,
        },
        {
            field : "InvAmountExclVat",
            headerName : t("Amount Excl. VAT"),
            cellStyle: { textAlign: 'right' },
            cellRenderer : (params) => {
                if (!params.value || !params.data?.InvCurrencyCode) return "";

                const amount = params.value;
                const currencyCode = params.data.InvCurrencyCode;
                return formatCurrencyDecimal(currencyCode, amount)
            },
            ...userSettings.InvAmountExclVat,
        },
        {
            field : "InvAmountInclVat",
            headerName : t("Amount Incl. VAT"),
            cellStyle : {
                //fontWeight: "bold",
                textAlign: 'right'
            },
            cellRenderer : (params) => {
                if (!params.value || !params.data?.InvCurrencyCode) return "";

                const amount = params.value;
                const currencyCode = params.data.InvCurrencyCode;
                const locale = i18n.language;
                return formatCurrencyDecimal(currencyCode, amount)
            },
            ...userSettings.InvAmountInclVat,
        },
        {
            field : "InvCurrencyCode",
            headerName : t("Currency"),
            flex:1,
            minWidth:100,
            ...userSettings.InvCurrencyCode,
        },
        {
            field : "InvTotalVatAmountCC",
            headerName : t("Amount VAT"),
            cellStyle : {
                fontWeight: "bold",
                textAlign: 'right'
            },
            cellRenderer : (params) => {
                if (!params.value || !params.data?.InvCurrencyCode) return "";

                const amount = params.value;
                const currencyCode = params.data.InvCurrencyCode;
                const locale = i18n.language;
                return formatCurrencyDecimal(currencyCode, amount)
            },
            ...userSettings.InvTotalVatAmountCC,
        },
        {
            field : "InvPrepaidAmount",
            headerName : t("Amount Prepaid"),
            cellStyle : {
                //fontWeight: "bold",
                textAlign: 'right'
            },
            cellRenderer : (params) => {
                if (!params.value || !params.data?.InvCurrencyCode) return "";

                const amount = params.value;
                const currencyCode = params.data.InvCurrencyCode;
                return formatCurrencyDecimal(currencyCode, amount)
            },
            ...userSettings.InvPrepaidAmount,
        },
        {
            field : "InvPayableAmount",
            headerName : t("Amount Payable"),
            cellStyle: { fontWeight: "bold", textAlign: 'right' },
            cellRenderer : (params) => {
                if (!params.value || !params.data?.InvCurrencyCode) return "";

                const amount = params.value;
                const currencyCode = params.data.InvCurrencyCode;
                return formatCurrencyDecimal(currencyCode, amount)
            },
            ...userSettings.InvPayableAmount,
        },
        {
            field : "InvStartDate",
            headerName : t("Started"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.InvStartDate,
        },
        {
            field : "InvEndDate",
            headerName : t("Ended"),
            //maxWidth:100,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.InvEndDate,
        },
        {
            field : "InvDueDate",
            headerName : t("Duedate"),
            //maxWidth:100,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.InvDueDate,
        },
        {
            field : "DeliveryDateActual",
            headerName : t("Delivered"),
            //maxWidth:100,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.DeliveryDateActual,
        },
        {
            field : "BuyerOrderRef",
            headerName : t("BuyerOrder"),
            sortable : true,
            ...userSettings.BuyerOrderRef,
        },
        {
            field : "ContractRef",
            headerName : t("Contract"),
            sortable : true,
            ...userSettings.ContractRef,
        },
        {
            field : "BuyerRef",
            headerName : t("BuyerRef"),
            sortable : true,
            ...userSettings.BuyerRef,
        },
        {
            field: "InvStatusSC__TAP_Status",
            headerName: t("TAP Status"),
            headerComponent: TapHeaderComponent,
            cellStyle: { display: 'flex', alignItems: 'center', padding: '0 8px' },
            cellRenderer: (params) => {
                const status = params?.value ? params.value : "";
                const comments = params?.data?.TAP_Comment || "";
                return (<>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <div style={{
                        flexGrow: 1,
                        minWidth: 0, // required for ellipsis
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                        {status}
                    </div>
                    {comments && (
                        <MuiTooltip title={comments}>
                            <MessageIcon fontSize="small" style={{ marginLeft: 4, color: 'rgba(0, 0, 0, 0.54)', flexShrink: 0 }}/>
                        </MuiTooltip>
                    )}
                </div>
                </>)
            },
            headerTooltip: "Tax Authority Portal",
            ...userSettings.InvStatusSC__TAP_Status,
        },
        {
            field : "Source",
            headerName : t("Source"),
            ...userSettings.Source,
        },
        //InvStartDate, InvEndDate, DocDeliveryDate, InvStatusSC__TAP_Status
        {
            field : "DateTimeCreate",
            headerName : t("Received"),
            //maxWidth:100,
            sort:"desc",
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false // Forces 24-hour format (e.g., "14:30" instead of "2:30 PM")
                });
            },
            ...userSettings.DateTimeCreate,
        },
        {
            field : "FiscMoment",
            headerName : t("Fiscal Moment"),
            //maxWidth:100,
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            ...userSettings.FiscMoment,
        },
        {
            field : "FiscTANum",
            headerName : t("Fiscal Tax Authority Number"),
            ...userSettings.FiscTANum,
        },
        {
            field : "FiscOperatorRegCode",
            headerName : t("Fiscal Operator"),
            ...userSettings.FiscOperatorRegCode,
        },
        {
            field : "Peppol_RR_DateTime",
            headerName : t("Peppol Date"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.Peppol_RR_DateTime,
        },
        {
            field : "Peppol_RR_ReceiverEA",
            headerName : t("Peppol Receiver"),
            ...userSettings.Peppol_RR_ReceiverEA,
        },
        {
            field : "NET_DateTime",
            headerName : t("NET Date"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.NET_DateTime,
        },
        {
            field : "NET_UniqueInvId",
            headerName : t("NET Id"),
            ...userSettings.NET_UniqueInvId,
        },
        {
            field : "PUSH_ERPDateTime",
            headerName : t("ERP Push Date"),
            cellStyle : {
                textAlign :"center"
            },
            cellRenderer : (params) => {
                if (!params.value) return "";
                const date = new Date(params.value);
                return date.toLocaleString(currentLanguage, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
            },
            ...userSettings.PUSH_ERPDateTime,
        },
    ];
        return colArr
        .sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
        .map(({ order, ...rest }) => rest);
    },[]);

    const getColumnSettings = () => {
        const columnApi = table.current?.api;
        if (!columnApi) return null;

        const columnState = columnApi.getColumnState(); // width + visible order
        const allColumns = columnApi.getAllGridColumns(); // for sort

        const settings = {};

        columnState.forEach((col, index) => {
            const gridCol = allColumns.find(c => c.getColId() === col.colId);

            settings[col.colId] = {
                order: index + 1,
                width: col.width,
                sort: gridCol?.getSort() ?? undefined,
                sortIndex: gridCol?.getSortIndex() ?? undefined,
            };
        });

        return settings;
    };

    const rowStyles = params => {
        const status = params?.data?.StepStatus;
        /* if (status === 'Error') return { backgroundColor: '#f8b3b3' };
        if (status === 'Warning') return { backgroundColor: '#d0d8ff' };
        if (status === 'Pending') return { backgroundColor: '#fdf0a1' }; */
        //if (status === 'OK') return { backgroundColor: '#c8f7c5' };
        return {};
    }

    const toClipboard = (val) =>{
        navigator.clipboard.writeText(val);
        NotificationManager.success(t("Copied"), "");
    }
    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            minWidth: 100,
            sortable: true,
            tooltipShowDelay: 0,
        }
    }, []);

    const onGridReady = useCallback((params) => {
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                setRequestParams(reqParams);
                reqParams.filter = filter;
                reqParams.mode = mode;
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                    if (res?.result?.data?.length > 0) {
                        setTimeout(() => {
                            params.api.getDisplayedRowAtIndex(0)?.setSelected(true);
                        }, 0);
                    }
                });
            }
        }
        params.api.setGridOption('datasource', dataSource);
    });

    const loadEntityData = ({startRow,endRow,search,filter,range,range2,type,state,mode,sortModel}) => {
        if(search && search?.length > 0){
            const ddd = new DDD(apiRequestAddress);
            const args = {
                format : "Full",
                includeCount : true,
                filter : getFilterFromSearch(search, filter, range, range2, type, state, mode),
                skip : startRow,
                take : endRow - startRow,
                orderBy : getOrderByFromArray(sortModel),
                destination : "REI",
                search : search
            }
            setCurrentFilter(getDisplayFilter(search, filter, range, range2, type, state, mode));
            return ddd.Rpc_ExecuteExtension("EUeInvoices.InvoicesSearch", args)

        }else{
            const e2data= new E2Data("EU_Invoices_REI");
            e2data.format="Full"
            e2data.includeCount=true;
            e2data.skip=startRow;
            e2data.take=endRow-startRow;
            e2data.component= "*";
            let select = getSelect(userPreferences, ["__invoiceType"], ["Id","DeviceId","StepStatus","Mode","InvTypeCodeNameSC__Code","InvPaymentTypeCodeNameSC__Code","InvSaleTypeSC__Code","Step","Peppol_RR_ReceiverEA","NET_UniqueInvId","eMail_SentTo","DeviceId__AssignedTo","FiscOperatorRegCode","FiscTANum","TAP_UniqueInvId","TAP_SellerInvId","InvObject_UI_View", "PDFPrimary", "PDFOriginal", "PDFHybrid", "XMLPeppol","PDFMade","PDFModified", "XMLSpecific","TAP_Comment"]);
            select = [...new Set(select)];
            e2data.select=select.join(",");
            e2data.filter=getFilterFromSearch(search, filter, range, range2, type, state, mode);
            setCurrentFilter(getDisplayFilter(search, filter, range, range2, type, state, mode));
            e2data.orderBy=getOrderByFromArray(sortModel);
            return e2data.GetData();
        }
    }

    const getOrderByFromArray = (arr) => {
        if(!arr?.length) return null;

        let order = "";
        arr.forEach(item => order+= item.colId + " " + item.sort+", ");
        order = order.replace(/, +$/, "");
        return order;
    }

    const getDisplayFilter = (globalSearch, filter, _range, _range2, _type, _state, _mode) => {
        let ff = "";
        if(globalSearch && globalSearch.trim() !=="")
            ff=`${t("Global search")}: ${globalSearch}`;
        if(_type && _type!== "null"){
            if(ff) ff += `, ${t("Type")}: ${_type}`;
            else ff += `${t("Type")}: ${_type}`;
        }
        if(_state && _state!== "null"){
            if(ff) ff += `, ${t("State")}: ${_state}`;
            else ff += `${t("State")}: ${_state}`;
        }
        if(_mode && _mode!== "null"){
            if(ff) ff += `, `;
            /* if(_mode==="PROD") ff += `${t("Mode")}: ${_mode}`;
            if(_mode==="TEST") ff += `${t("Mode")}: ${_mode} OR null`; */
            if(_mode==="PROD") ff += `${t("Mode")}: ${_mode} OR (null and ModeREI="ON")`;
            if(_mode==="TEST") ff += `${t("Mode")}: ${_mode} OR (null and ModeREI="OFF")`;
        }
        
        if(_range?.[0]?.startDate && _range?.[0]?.endDate){
            const start = new Date(_range[0].startDate);
            const end = new Date(_range[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if(ff) ff += `, ${dateField}: ${startStr} - ${endStr}`;
            else ff += `${dateField}: ${startStr} - ${endStr}`;
        }

        if(_range2?.[0]?.startDate && _range2?.[0]?.endDate){
            const start = new Date(_range2[0].startDate);
            const end = new Date(_range2[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if(ff) ff += `, ${dateField2}: ${startStr} - ${endStr}`;
            else ff += `${dateField2}: ${startStr} - ${endStr}`;
        }
        return ff;
    }
    const getFilterFromSearch = (globalSearch, filter, _range, _range2, _type, _state,_mode) =>{
        let ff="";
        //if((!globalSearch || globalSearch.trim() ==="") && !filter) return null;

        /* if(globalSearch && globalSearch.trim() !=="")
            ff=`BuyerFormalName contains "${globalSearch}" OR BuyerTaxNum contains "${globalSearch}" OR BuyerRegNum contains "${globalSearch}" 
            OR BuyerVatNum contains "${globalSearch}" OR BuyerBudgetNum contains "${globalSearch}" OR BuyerCounCode="${globalSearch}" 
            OR BuyerOrderRef contains "${globalSearch}" OR InvNum contains "${globalSearch}" OR InvAmountInclVat = "${globalSearch}"
            OR InvAmountExclVat = "${globalSearch}" OR InvCurrencyCode = "${globalSearch}" OR InvStatusSC__TAP_Status contains "${globalSearch}"
            OR FiscTANum contains "${globalSearch}" OR FiscOperatorRegCode contains "${globalSearch}" OR TAP_UniqueInvId contains "${globalSearch}"
            OR TAP_SellerInvId contains "${globalSearch}" OR Peppol_RR_ReceiverEA contains "${globalSearch}" OR NET_UniqueInvId contains "${globalSearch}"
            OR eMail_SentTo contains "${globalSearch}" OR Source contains "${globalSearch}"`; */
        if(filter){
            if(ff) ff= `(${ff}) AND `;
            ff += filter;
        }
        if(_type && _type!== "null"){
            if(ff) ff= `(${ff}) AND `;
            ff += `InvTypeCodeNameSC__Code = "${_type}"`;
        }
        if(_state && _state!== "null"){
            if(ff) ff= `(${ff}) AND `;
            if (_state === "Draft") {
                ff += `Step < 35`;
            } else {
                ff += `StepStatus = "${_state}"`;
            }
        }
        if(_mode && _mode!== "null"){
            if(ff) ff= `(${ff}) AND `;
            /* if(_mode==="PROD") ff += `Mode = "${_mode}"`;
            if(_mode==="TEST") ff += `(Mode = "${_mode}" OR Mode = null)`; */
            /* if(_mode==="PROD") ff += `(Mode = "PROD" OR (Mode=null AND DeviceId__Mode="PROD"))`;
            if(_mode==="TEST") ff += `(Mode = "TEST" OR (Mode=null AND DeviceId__Mode="TEST"))`; */
            if(_mode==="PROD") ff += `(Mode = "PROD"` + (sessionInfo?.Extended?.ModeREI==="PROD" ? ` OR Mode=null)` : ")");
            if(_mode==="TEST") ff += `(Mode = "TEST"` + (sessionInfo?.Extended?.ModeREI==="TEST" ? ` OR Mode=null)` : ")");
        }
        
        if(_range?.[0]?.startDate && _range?.[0]?.endDate){
            const start = new Date(_range[0].startDate);
            const end = new Date(_range[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if (ff) ff = `(${ff}) AND `;
            ff += `${dateField} >= "${startStr}" AND ${dateField} <= "${endStr}"`;
        }

        if(_range2?.[0]?.startDate && _range2?.[0]?.endDate){
            const start = new Date(_range2[0].startDate);
            const end = new Date(_range2[0].endDate);

            start.setHours(0, 0, 0, 0);              // 00:00:00.000
            end.setHours(23, 59, 59, 999);           // 23:59:59.999

            const startStr = start.toLocaleString('sv-SE').replace(' ', 'T');
            const endStr = end.toLocaleString('sv-SE').replace(' ', 'T');

            if (ff) ff = `(${ff}) AND `;
            ff += `${dateField2} >= "${startStr}" AND ${dateField2} <= "${endStr}"`;
        }
        return ff==="" ? null : ff;
    }

    useEffectIgnoreFirst(() =>{
        const dataSource = {
            rowCount: undefined,
            getRows: (reqParams) => {
                reqParams.search = search;
                reqParams.filter = filter;
                reqParams.type = type;
                reqParams.range = range;
                reqParams.range2 = range2;
                reqParams.state = state;
                reqParams.mode = mode;
                setRequestParams(reqParams);
                loadEntityData(reqParams).then((res) =>{
                    setTotalRecords(res?.result?.count ?? "-");
                    reqParams.successCallback(res?.result?.data, res?.result?.count);
                });
            }
        }
        table?.current?.api?.setGridOption('datasource', dataSource);
    }, [search, filter, reloadNum, range, range2, state, type, mode]);

    const onSelectionChanged = (event) => {
        const selectedNode = event.api.getSelectedNodes()?.[0]; // node object
        const selectedData = selectedNode?.data;
        if(selectedData && onRowSelect) onRowSelect(selectedData);
    };

    const handleRightClick = (event) => {
        event.event.preventDefault();
        if(onRightClick) onRightClick(event?.data, event)
    };


    if(!entityInfo) return null;
    return(
        <div style={{position:"relative", height: '100%', width: '100%' }} className={"ag-theme-balham custom-ag-grid"} onContextMenu={(e) => e.preventDefault()}>
            <AgGridReact
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowBuffer={0}
                getRowStyle={rowStyles}
                rowSelection={'single'}
                rowModelType={'infinite'}
                cacheBlockSize={100}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1000}
                maxBlocksInCache={10}
                onGridReady={onGridReady}
                ref = {table}
                onSelectionChanged={onSelectionChanged}
                onCellContextMenu={handleRightClick}
            />
            <div style={{
                position: 'absolute',
                bottom: '3px',
                right: '5px',
                cursor: 'pointer',
                zIndex: 10
            }}
                className="tooltip-container"
            >
                <MuiTooltip title={<>
                    <div className="mb-2">{t("Table status")}</div>
                        <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Number od records")}: {totalRecords}</p>
                        {currentFilter!=="" && <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Filter")}: {currentFilter}</p>}
                </>} placement="top">
                    <HelpIcon style={{fontSize:"0.8rem", color:"var(--main-blue)"}}/>
                </MuiTooltip>
                {/* <OverlayTrigger placement="top" 
                    overlay={<Tooltip>
                        <div className="mb-2">{t("Table status")}</div>
                        <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Number od records")}: {totalRecords}</p>
                        {currentFilter!=="" && <p style={{ textAlign: "left", marginBottom: 4 }}>{t("Filter")}: {currentFilter}</p>}
                        </Tooltip>}>
                    <HelpIcon style={{fontSize:"0.8rem", color:"var(--main-blue)"}}/>
                </OverlayTrigger> */}
            </div>
        </div>
    )
});


export default InvoicesTableREI;

const getStatusIcon = (status) => {
    const iconStyle = { 
      fontSize: '1rem', 
      marginRight: '4px',
      verticalAlign: 'middle'
    };
  
    switch (status) {
      // Approved states
      case 'Approved':
      case 'ApprovedByReceiver':
        return <ApprovedIcon style={{ ...iconStyle, color: '#43a047' }} />; // Green
      
      // Rejected states
      case 'Rejected':
      case 'RejectedPA':
      case 'RejectedByReceiver':
        return <RejectedIcon style={{ ...iconStyle, color: '#e57373' }} />; // Red
      
      // Received states (including typos)
      case 'Received':
      case 'MessageRecieved': // Typo preserved
      case 'MessageReceived':
        return <MessageIcon style={{ ...iconStyle, color: '#1976d2' }} />; // Blue
      
      // Payment related
      case 'Paid':
      case 'DeliveredPA':
      case 'AcceptedPA':
        return <PaymentIcon style={{ ...iconStyle, color: '#4caf50' }} />; // Green
      
      // Cancelled states (both spellings)
      case 'Cancelled':
      case 'Canceled':
        return <CancelledIcon style={{ ...iconStyle, color: '#f44336' }} />; // Red
      
      // Message states
      case 'MessageSent':
      case 'Sent':
        return <SentIcon style={{ ...iconStyle, color: '#2196f3' }} />; // Blue
      
      // Error states
      case 'Error':
      case 'TAPTechnicalError':
        return <ErrorIcon style={{ ...iconStyle, color: '#ff9800' }} />; // Amber
      
      // Special cases
      case 'Storno':
      case 'StornoOfApprovedInv':
        return <StornoIcon style={{ ...iconStyle, color: '#9c27b0' }} />; // Purple
      case 'Quarrantena':
        return <QuarantineIcon style={{ ...iconStyle, color: '#ff5722' }} />; // Deep orange
      case 'TAPArchived':
        return <ArchivedIcon style={{ ...iconStyle, color: '#607d8b' }} />; // Blue grey
      case 'Seen':
        return <SeenIcon style={{ ...iconStyle, color: '#00bcd4' }} />; // Cyan
      case 'Reminded':
      case 'Renotified':
        return <RemindedIcon style={{ ...iconStyle, color: '#ffc107' }} />; // Amber
      case 'Waiting':
        return <WaitingIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey
    case 'New':
        return <FiberNewIcon style={{ ...iconStyle, color: '#ffb74d' }} />; // Deep orange, stands out
      
      // Default
      case 'Unknown':
      case 'NotDelivered':
      case 'DeadlineTerms':
      default:
        return <UnknownIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey
    }
};

const getInvoiceTypeIcon = (invoiceType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color:"var(--main-blue)" };
  
    switch (invoiceType) {
      case 'INVOICECZ':
        return <Receipt style={{ ...iconStyle, color: '#1976d2' }} />; // Blue
      case 'INVOICESB':
        return <Receipt style={{ ...iconStyle, color: '#388e3c' }} />; // Green
      case 'PROFORMA':
        return <Description style={{ ...iconStyle, color: '#ffa000' }} />; // Amber
      case 'SELFINVOICE':
        return <History style={{ ...iconStyle, color: '#7b1fa2' }} />; // Purple
      case 'CORRECTIVE':
      case 'CORRECTIVECREDITNOTE':
        return <EditNote style={{ ...iconStyle, color: '#d32f2f' }} />; // Red
      case 'PARTIALINVOICE':
      case 'PARTIALFINALCONSTRINVOICE':
        return <AttachMoney style={{ ...iconStyle, color: '#0288d1' }} />; // Light blue
      case 'ADVANCE':
      case 'CORRECTIVEADVANCE':
        return <Paid style={{ ...iconStyle, color: '#689f38' }} />; // Light green
      case 'CREDITNOTE':
        return <CreditScore style={{ ...iconStyle, color: '#5c6bc0' }} />; // Indigo
      case 'FINALCONSTRINVOICE':
      case 'PARTIALCONSTRINVOICE':
        return <ReceiptLong style={{ ...iconStyle, color: '#5d4037' }} />; // Brown
      case 'INVOICE':
      default:
        return <Receipt style={iconStyle} />; // Default
    }
};

const getPaymentTypeIcon = (paymentType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    switch (paymentType) {
      case 'CASH':
        return <Payments style={{ ...iconStyle, color: '#43a047' }} />; // Green (cash payment icon)
      case 'NONCASH':
        return <AccountBalanceIcon style={{ ...iconStyle, color: '#1976d2' }} />
      case 'COMBINE':
        return <MonetizationOn style={{ ...iconStyle, color: '#f9a825' }} />; // Amber (money with dollar)
      default:
        return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Grey question mark
    }
};

const getSaleTypeIcon = (saleType) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    switch (saleType) {
      case 'Retailsale':
        return <Storefront style={{ ...iconStyle, color: '#4caf50' }} />; // Green - Retail shop
      case 'Wholesale':
        return <BusinessCenter style={{ ...iconStyle, color: '#1976d2' }} />; // Blue - Briefcase for business
      case null:
      case 'null':
      default:
        return <HelpOutline style={{ ...iconStyle, color: '#9e9e9e' }} />; // Gray - Unknown/default
    }
};
/*style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(previewPrefix+"/"+selectedRow.PDFPrimary, '_blank');
                                }}*/
const getPDFOriginalIcon = (pdfOriginal) => {
    const iconStyle = { fontSize: '1rem', marginRight: '4px', color: 'var(--main-blue)' };
  
    if(pdfOriginal) {
        return <PictureAsPdfIcon style={{ ...iconStyle, color: '#4caf50', cursor: 'pointer' }}  onClick={(e) => {e.stopPropagation(); window.open("/"+pdfOriginal, '_blank');}}/>; 
    }
    return <PictureAsPdfIcon style={{ ...iconStyle, color: '#9e9e9e' }} />; // Gray - Unknown/default
};

const TapHeaderComponent = (props) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px',maxWidth: '100%', overflow: 'hidden' }}>
        <OverlayTrigger placement="top" overlay={<Tooltip>{"Tax Authority Portal"}</Tooltip>}>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" 
                        fill="var(--main-blue)" 
                        stroke="black" 
                        stroke-width="1"/>
                <text x="12" y="15" 
                        font-family="Arial, sans-serif" 
                        font-size="8" 
                        font-weight="bold" 
                        text-anchor="middle" 
                        fill="white">TAP</text>
            </svg>
        </OverlayTrigger>
        <span style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%'
        }}>
          {props.displayName}
        </span>
      </div>
    );
}

const mergeObjects = (obj1, obj2) => {
    if (obj2) {
        for (const key in obj2) {
            if(!obj2[key].sort) obj2[key].sort = undefined; // Ensure sort is always defined
            if(!obj2[key].sortIndex && obj2[key].sortIndex !==0) obj2[key].sortIndex = undefined; // Ensure sort is always defined
            obj1[key] = {
            ...obj1[key],
            ...obj2[key],
            };
        }
    }
    return obj1;
}

/**
 * Returns the number of decimal places for a currency (from ISO 4217).
 * Defaults to 2 if currency is unknown.
 */
const getCurrencyDecimals = (currencyCode) => {
  if (!currencyCode) return 2;

  // All exceptions (currencies NOT using 2 decimals)
  // Source: https://en.wikipedia.org/wiki/ISO_4217
  const currencyDecimals= {
    // 0 decimals
    'BIF': 0, 'CLP': 0, 'DJF': 0, 'GNF': 0, 'ISK': 0, 'JPY': 0,
    'KMF': 0, 'KRW': 0, 'PYG': 0, 'RWF': 0, 'UGX': 0, 'VND': 0, 'VUV': 0,
    'XAF': 0, 'XOF': 0, 'XPF': 0,

    // 1 decimal
    'MGA': 1, 'MRU': 1,

    // 3 decimals
    'BHD': 3, 'IQD': 3, 'JOD': 3, 'KWD': 3, 'LYD': 3, 'OMR': 3, 'TND': 3,

    // 4 decimals (very rare)
    'CLF': 4,
  };

  return currencyDecimals[currencyCode.toUpperCase()] ?? 2; // Default: 2
}
const formatCurrencyDecimal = (currencyCode, value) => {
    if (value === null || value === undefined) return null;

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return null;

    const decimals = getCurrencyDecimals(currencyCode);
    const factor = 10 ** decimals;
    const roundedValue =  Math.round(numericValue * factor) / factor;
    return roundedValue.toFixed(decimals);
}
  